import axios from 'axios'
const host = 'https://backend.firstpi.cn' // $domain
const api = host + '/api/blockchain/'

export function $get (url, params) {
  let config = {
    params: params
  }
  return axios.get(api + url, config)
}



// WEBPACK FOOTER //
// ./src/utils/http.js